import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";


import common_en from "../locales/en/common.json";
import activities_en from "../locales/en/activities.json";

import common_fr from "../locales/fr/common.json";
import activities_fr from "../locales/fr/activities.json";

import rgpd_en from "../locales/en/rgpd.json";
import rgpd_fr from "../locales/fr/rgpd.json";

const resources = {
	en: {
		common: common_en,
		activities: activities_en,
		rgpd: rgpd_en
	},
	fr: {
		common: common_fr,
		activities: activities_fr,
		rgpd: rgpd_fr
	}
};

const options = {
	order: ["localStorage", "navigator", "queryString", "cookie", "subdomain", "htmlTag"],
	lookupCookie: "i18next",
	lookupLocalStorage: "i18next"
};

i18next
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: true,
		resources,
		detection: options,
		lng: "fr",
		supportedLngs: ["en", "fr"],
		fallbackLng: "fr",
		nonExplicitSupportedLngs: true,
		interpolation: {
			escapeValue: false
		},
		react: {
			useSuspense: false
		}
	});

export default i18next;
